<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!loading" dark icon title="Print Reports" @click="showReportsMenu">
                        <v-icon>fa-solid fa-file</v-icon>
                    </v-btn>
                    <help-link appId="attendance" pageId="timesheet-review" color="white"></help-link>          
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this timesheet.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="green" dark title="This period is already Closed. You will not be able to change this timesheet.">Closed</v-chip>
                </v-toolbar>
            </v-card>
            <v-card class="elavation-1 mt-5"> 
               <v-toolbar flat height="45px">  
                    <div class="mb-10 wp-40">
                        <v-text-field v-model="search" append-icon="search" label="Search name" single-line hide-details></v-text-field>
                    </div>                  
                    <v-spacer></v-spacer>  
                    <b>{{selectedPeriod}}</b>                          
                </v-toolbar>
                <v-data-table
                    :headers="headers"
                    :items="time_reports_filtered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                >
                    <template v-slot:items="props">
                        <tr @click="viewUserTimesheet(props.item)" title="Click to view details, approve, reject" class="clickable">
                            <td>
                                <v-chip @click="viewUserProfile(props.item, $store.state.userId)" class="user-chip-container">
                                    <v-avatar>
                                        <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                    </v-avatar>
                                    {{props.item.firstName}} {{props.item.lastName}}
                                </v-chip>
                            </td>
                            <td>
                                <b v-if="commonfn.getStatusDescription(props.item.status)=='Not Available'" :class="commonfn.getStatusColor(props.item.status)">Unsubmitted</b>
                                <b v-else :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                            </td>
                            <td>
                                <span v-if="props.item.createdOn">
                                    <span v-if="isMobile">{{ props.item.createdOn | moment('MMM DD')}}</span>
                                    <span v-else>{{ props.item.createdOn | moment('MMM DD, YYYY')}}</span>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>

        <v-dialog v-model="dialogReports" persistent width="550">
            <reports ref="reportsRef" :dialogReports.sync="dialogReports"></reports>
        </v-dialog>
    </v-layout>  
</template>

<script>

import timesheetApi from '@/api/timesheet'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import awsS3Helper from '@/helpers/aws-s3'

export default {   
    name: 'Team Timesheet',
    metaInfo: {
        title: 'Team Timesheet',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Team Timesheet' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },   
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'reports': () => import('@/components/Timesheet/TimesheetReports'),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: userPrefs.getSearchKeyword(routeName),
            dialogReports: false,
            error: false,
            errorMessage: '',
            loading: false,
            loading_download: false,
            headers: [
                {text: 'Employee', align: 'left', value: 'firstName', width:'40%', sortable:true},
                {text: 'Status', align: 'left', value: 'status', width: '30%', sortable:true},
                {text: 'Created On', align: 'left', value:'createdOn', width: '30%', sortable:true}
            ],
            cutoff_periods: [],
            current_index: 0,
            selected_period: [],
            time_reports: []
        }
    },
    methods: {   
        showReportsMenu() {
            var data = {
                selectedCutOffId: this.selectedCutOffId,
                selectedPeriod: this.selectedPeriod,
                selectedTeamId: this.$store.state.selectedTeamId
            }
            this.$refs.reportsRef.setParam(data)
            this.dialogReports=true
        },
        viewUserTimesheet(data) {
            this.$router.push(`/myteam/timesheet/${this.selectedCutOffId}/${data.userId}`)
        },
        async getTeamTimeReports() {
            try {
                this.loading = true
                const response = await timesheetApi.getTimeReportByTeam(this.selectedCutOffId)              
                if (response && response.status == 200) {
                    this.selected_period = response.data.cutOffItem
                    this.time_reports = response.data.items
                }
                 this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    async created() { 
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.$store.state.selectedTeamName} Timesheets`
        })

        this.getTeamTimeReports()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal);
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        time_reports_filtered() {
            var temp = this.time_reports

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.firstName.toLowerCase().includes(this.search.toLowerCase()) || item.lastName.toLowerCase().includes(this.search.toLowerCase()))
                })
            }
            return temp
        },
        selectedPeriod() {
            if (this.selected_period)
                return this.$moment(this.selected_period.cutoffStart).format("MMM DD, YYYY") + " - " + this.$moment(this.selected_period.cutoffEnd).format("MMM DD, YYYY") 
            return ''
        },
        frozenPeriod(){
            if (this.selected_period)
                return this.selected_period.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod(){
            if (this.selected_period)
                return this.selected_period.status==commonfn.getStatusCode('Closed')
        },
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>